import styled from '@emotion/styled'
import { FlexRow } from './Containers'

// File table specific styles
const Container = styled.div`
  container-type: inline-size;
  width: 100%;
`

const Stackable = styled(FlexRow)`
  width: 100%;
  gap: 10px 20px;
  @container (max-width: 450px) {
    flex-wrap: wrap;
  }
`

const FirstItem = styled.div`
  width: 80px;
  min-width: 80px;
`

const LargeItem = styled.div`
  flex-basis: 50%;
  min-width: 0;
  align-self: center;

  text-wrap: wrap;
  word-break: break-word;

  @container (max-width: 450px) {
    flex-basis: 100%;
  }
`

const MedItem = styled(LargeItem)`
  flex-basis: 20%;
`

const SmallItem = styled(LargeItem)`
  flex-basis: ${props => (props.isRemoved ? '15%' : '25%')};
`

const SmallItemRight = styled(SmallItem)`
  text-align: right;

  @container (max-width: 450px) {
    text-align: left;
  }
`

export { Container, Stackable, FirstItem, LargeItem, MedItem, SmallItem, SmallItemRight }
